import * as Types from '../generated/graphql-schema';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ProviderFieldsFragment = { __typename?: 'Provider', id: string, public_profile?: { __typename?: 'ProviderPublicProfile', display_name?: string | null, url_slug?: string | null, logo_image_url?: string | null, banner_image_url?: string | null, display_bio?: string | null, services_category?: Types.ProviderServiceCategory | null, primary_color?: string | null, secondary_color?: string | null, locale?: { __typename?: 'ProviderLocale', currency?: string | null, locale?: string | null } | null } | null, business_settings?: { __typename?: 'ProviderBusinessSettings', services_category?: Types.ProviderServiceCategory | null, country?: string | null, managed_phone_number?: string | null, contact_info?: { __typename?: 'ProviderContactInfo', contact_email?: string | null, contact_phone?: string | null } | null } | null, policies?: { __typename?: 'ProviderPolicies', cancellation_policies?: Array<{ __typename?: 'CancellationPolicy', charge_time_offset_min?: number | null, fixed_amount?: number | null, percent?: number | null }> | null, payment_charge_policy?: { __typename?: 'PaymentChargePolicy', upfront_charge_percent?: number | null, upfront_charge_amount?: number | null, remaining_amount_when_status?: Types.ReservationStatus | null, accepted_payment_methods?: Array<Types.PaymentMethodType> | null } | null, reservation_requirements?: { __typename?: 'ProviderReservationRequirements', requires_access_to_power?: boolean | null, requires_access_to_water?: boolean | null } | null } | null, members?: Array<{ __typename?: 'ProTeamMember', id: string, role?: Types.ProRole | null, status?: Types.ProTeamMemberStatus | null, invited_at?: number | null, user?: { __typename?: 'ProUser', id: string, display_name?: string | null, full_name?: string | null, email?: string | null, phone_number?: string | null } | null }> | null };

export type FleetFieldsFragment = { __typename?: 'Fleet', id: string, name: string, owner_uid: string, discount_id?: string | null };

export type GetProviderQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id: string, public_profile?: { __typename?: 'ProviderPublicProfile', display_name?: string | null, url_slug?: string | null, logo_image_url?: string | null, banner_image_url?: string | null, display_bio?: string | null, services_category?: Types.ProviderServiceCategory | null, primary_color?: string | null, secondary_color?: string | null, locale?: { __typename?: 'ProviderLocale', currency?: string | null, locale?: string | null } | null } | null, business_settings?: { __typename?: 'ProviderBusinessSettings', services_category?: Types.ProviderServiceCategory | null, country?: string | null, managed_phone_number?: string | null, contact_info?: { __typename?: 'ProviderContactInfo', contact_email?: string | null, contact_phone?: string | null } | null } | null, policies?: { __typename?: 'ProviderPolicies', cancellation_policies?: Array<{ __typename?: 'CancellationPolicy', charge_time_offset_min?: number | null, fixed_amount?: number | null, percent?: number | null }> | null, payment_charge_policy?: { __typename?: 'PaymentChargePolicy', upfront_charge_percent?: number | null, upfront_charge_amount?: number | null, remaining_amount_when_status?: Types.ReservationStatus | null, accepted_payment_methods?: Array<Types.PaymentMethodType> | null } | null, reservation_requirements?: { __typename?: 'ProviderReservationRequirements', requires_access_to_power?: boolean | null, requires_access_to_water?: boolean | null } | null } | null, members?: Array<{ __typename?: 'ProTeamMember', id: string, role?: Types.ProRole | null, status?: Types.ProTeamMemberStatus | null, invited_at?: number | null, user?: { __typename?: 'ProUser', id: string, display_name?: string | null, full_name?: string | null, email?: string | null, phone_number?: string | null } | null }> | null } | null };

export type GetProviderBySlugQueryVariables = Types.Exact<{
  slug: Types.Scalars['String'];
}>;


export type GetProviderBySlugQuery = { __typename?: 'Query', providerBySlug?: { __typename?: 'Provider', id: string, public_profile?: { __typename?: 'ProviderPublicProfile', display_name?: string | null, url_slug?: string | null, logo_image_url?: string | null, banner_image_url?: string | null, display_bio?: string | null, services_category?: Types.ProviderServiceCategory | null, primary_color?: string | null, secondary_color?: string | null, locale?: { __typename?: 'ProviderLocale', currency?: string | null, locale?: string | null } | null } | null, business_settings?: { __typename?: 'ProviderBusinessSettings', services_category?: Types.ProviderServiceCategory | null, country?: string | null, managed_phone_number?: string | null, contact_info?: { __typename?: 'ProviderContactInfo', contact_email?: string | null, contact_phone?: string | null } | null } | null, policies?: { __typename?: 'ProviderPolicies', cancellation_policies?: Array<{ __typename?: 'CancellationPolicy', charge_time_offset_min?: number | null, fixed_amount?: number | null, percent?: number | null }> | null, payment_charge_policy?: { __typename?: 'PaymentChargePolicy', upfront_charge_percent?: number | null, upfront_charge_amount?: number | null, remaining_amount_when_status?: Types.ReservationStatus | null, accepted_payment_methods?: Array<Types.PaymentMethodType> | null } | null, reservation_requirements?: { __typename?: 'ProviderReservationRequirements', requires_access_to_power?: boolean | null, requires_access_to_water?: boolean | null } | null } | null, members?: Array<{ __typename?: 'ProTeamMember', id: string, role?: Types.ProRole | null, status?: Types.ProTeamMemberStatus | null, invited_at?: number | null, user?: { __typename?: 'ProUser', id: string, display_name?: string | null, full_name?: string | null, email?: string | null, phone_number?: string | null } | null }> | null } | null };

export type ListFleetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListFleetsQuery = { __typename?: 'Query', fleets: Array<{ __typename?: 'Fleet', id: string, name: string, owner_uid: string, discount_id?: string | null }> };

export type GetFleetQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetFleetQuery = { __typename?: 'Query', fleet: { __typename?: 'Fleet', id: string, name: string, owner_uid: string, discount_id?: string | null } };

export type CustomerAssetsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID'];
  type?: Types.InputMaybe<Types.CustomerAssetType>;
}>;


export type CustomerAssetsQuery = { __typename?: 'Query', customerAssets: Array<{ __typename?: 'CustomerAsset', id: string, type: Types.CustomerAssetType, name?: string | null, notes?: string | null, customer_id: string, specifications?: { __typename?: 'PropertySpecification', address?: string | null, city?: string | null, state?: string | null, postal_code?: string | null, latitude?: number | null, longitude?: number | null } | { __typename?: 'VehicleSpecification', make?: string | null, model?: string | null, year?: string | null, color?: string | null, size?: Types.VehicleSize | null, license_plate?: string | null } | null }> };

export type OperatorMeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OperatorMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email?: string | null, display_name?: string | null, full_name?: string | null, group: Types.UserGroup, is_operator?: boolean | null, providers?: Array<{ __typename?: 'Provider', id: string, public_profile?: { __typename?: 'ProviderPublicProfile', display_name?: string | null, url_slug?: string | null } | null }> | null } | null };

export type CreateFleetMutationVariables = Types.Exact<{
  data: Types.CreateFleetInput;
}>;


export type CreateFleetMutation = { __typename?: 'Mutation', createFleet: { __typename?: 'Fleet', id: string, name: string, owner_uid: string, discount_id?: string | null } };

export type UpdateFleetMutationVariables = Types.Exact<{
  data: Types.UpdateFleetInput;
}>;


export type UpdateFleetMutation = { __typename?: 'Mutation', updateFleet: { __typename?: 'Fleet', id: string, name: string, owner_uid: string, discount_id?: string | null } };

export const ProviderFieldsFragmentDoc = gql`
    fragment ProviderFields on Provider {
  id
  public_profile {
    display_name
    url_slug
    logo_image_url
    banner_image_url
    display_bio
    services_category
    primary_color
    secondary_color
    locale {
      currency
      locale
    }
  }
  business_settings {
    services_category
    country
    managed_phone_number
    contact_info {
      contact_email
      contact_phone
    }
  }
  policies {
    cancellation_policies {
      charge_time_offset_min
      fixed_amount
      percent
    }
    payment_charge_policy {
      upfront_charge_percent
      upfront_charge_amount
      remaining_amount_when_status
      accepted_payment_methods
    }
    reservation_requirements {
      requires_access_to_power
      requires_access_to_water
    }
  }
  members {
    id
    role
    status
    invited_at
    user {
      id
      display_name
      full_name
      email
      phone_number
    }
  }
}
    `;
export const FleetFieldsFragmentDoc = gql`
    fragment FleetFields on Fleet {
  id
  name
  owner_uid
  discount_id
}
    `;
export const GetProviderDocument = gql`
    query GetProvider($id: String!) {
  provider(id: $id) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProviderGQL extends Apollo.Query<GetProviderQuery, GetProviderQueryVariables> {
    document = GetProviderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProviderBySlugDocument = gql`
    query GetProviderBySlug($slug: String!) {
  providerBySlug(slug: $slug) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProviderBySlugGQL extends Apollo.Query<GetProviderBySlugQuery, GetProviderBySlugQueryVariables> {
    document = GetProviderBySlugDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListFleetsDocument = gql`
    query ListFleets {
  fleets {
    ...FleetFields
  }
}
    ${FleetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListFleetsGQL extends Apollo.Query<ListFleetsQuery, ListFleetsQueryVariables> {
    document = ListFleetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFleetDocument = gql`
    query GetFleet($id: String!) {
  fleet(id: $id) {
    ...FleetFields
  }
}
    ${FleetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFleetGQL extends Apollo.Query<GetFleetQuery, GetFleetQueryVariables> {
    document = GetFleetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerAssetsDocument = gql`
    query CustomerAssets($customerId: ID!, $type: CustomerAssetType) {
  customerAssets(customerId: $customerId, type: $type) {
    id
    type
    name
    notes
    customer_id
    specifications {
      ... on VehicleSpecification {
        make
        model
        year
        color
        size
        license_plate
      }
      ... on PropertySpecification {
        address
        city
        state
        postal_code
        latitude
        longitude
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerAssetsGQL extends Apollo.Query<CustomerAssetsQuery, CustomerAssetsQueryVariables> {
    document = CustomerAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OperatorMeDocument = gql`
    query OperatorMe {
  me {
    id
    email
    display_name
    full_name
    group
    is_operator
    providers {
      id
      public_profile {
        display_name
        url_slug
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OperatorMeGQL extends Apollo.Query<OperatorMeQuery, OperatorMeQueryVariables> {
    document = OperatorMeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFleetDocument = gql`
    mutation CreateFleet($data: CreateFleetInput!) {
  createFleet(data: $data) {
    ...FleetFields
  }
}
    ${FleetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFleetGQL extends Apollo.Mutation<CreateFleetMutation, CreateFleetMutationVariables> {
    document = CreateFleetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFleetDocument = gql`
    mutation UpdateFleet($data: UpdateFleetInput!) {
  updateFleet(data: $data) {
    ...FleetFields
  }
}
    ${FleetFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFleetGQL extends Apollo.Mutation<UpdateFleetMutation, UpdateFleetMutationVariables> {
    document = UpdateFleetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }